import { useContext } from 'react';
import { AuthContext } from '../../providers/AuthProvider';
import { ApiMethod } from '../models/api-types.type';
import { routes } from '../../assets/constants';
import type { CostDays, CostProviderId, CostSettings, CostsResponse } from '../models/platform-costs.model';

/** What Ardealy pays its providers (super-admin). */
export const usePlatformCostsApi = () => {
  const { sendAuthGuardedRequest } = useContext(AuthContext);
  return {
    getCosts: (days: CostDays, fresh = false) =>
      sendAuthGuardedRequest(ApiMethod.GET, `${routes.adminCosts}?days=${days}${fresh ? '&fresh=1' : ''}`) as Promise<CostsResponse>,
    updateSettings: (patch: Partial<CostSettings>) => sendAuthGuardedRequest(ApiMethod.PUT, `${routes.adminCosts}/settings`, patch) as Promise<CostSettings>,
    sync: (provider?: CostProviderId) =>
      sendAuthGuardedRequest(ApiMethod.POST, `${routes.adminCosts}/sync${provider ? `?provider=${provider}` : ''}`, {}) as Promise<{ synced: CostProviderId[] }>,
  };
};
